// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","blue":"#00afef","guidance":"kSiAL62","list":"_3TfeX63","item":"_1btnsko","textarea":"_1YatfPh","item_nolabel":"_2o6NMPd _1btnsko"};